import { Heading, Text } from '@noorden-insurtech/alba-design-system';

interface AuthHeaderProps {
  title: string;
  subtitle: string;
}

export function AuthHeader({ title, subtitle }: AuthHeaderProps) {
  return (
    <div className='flex flex-col gap-2 items-start justify-center w-full'>
      <Heading size='lg' className='text-[#2c2864] font-bold'>
        {title}
      </Heading>
      <Text size='sm' className='text-[#2c2864]'>
        {subtitle}
      </Text>
    </div>
  );
}
